"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.saveJsonTableAsCsv = saveJsonTableAsCsv, exports.exportRowsToCsv = exportRowsToCsv;

var _fileSaver = require("file-saver"),
    _fileSaver2 = _interopRequireDefault(_fileSaver);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function saveFile(a, b) {
  _fileSaver2.default.saveAs(a, b);
}

function saveJsonTableAsCsv(a) {
  var b = a.jsonTable,
      c = a.fileName,
      d = a.fields,
      e = void 0; //console.log("Fields", fields);

  if (!!d) {
    var f = require("json2csv"),
        g = f.Parser,
        h = new g({
      fields: d
    });

    e = h.parse(b);
  } else {
    var j = require("json2csv").parse;

    e = j(b);
  }

  var i = new Blob([e], {
    type: "text/csv;charset=utf-8"
  });
  saveFile(i, c);
}

exports.default = saveFile;

function exportRowsToCsv(a, b) {
  for (var c = function c(a) {
    for (var b, c = "", d = 0; d < a.length; d++) {
      b = null === a[d] ? "" : a[d].toString(), a[d] instanceof Date && (b = a[d].toLocaleString());
      var e = b.replace(/"/g, "\"\"");
      0 <= e.search(/("|,|\n)/g) && (e = "\"" + e + "\""), 0 < d && (c += ","), c += e;
    }

    return c + "\n";
  }, d = "", e = 0; e < a.length; e++) {
    d += c(a[e]);
  }

  var f = new Blob([d], {
    type: "text/csv;charset=utf-8;"
  });
  if ("undefined" != typeof window && window.navigator.msSaveBlob) // IE 10+
    window.navigator.msSaveBlob(f, b);else {
    var g = document.createElement("a");

    if (g.download !== void 0) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var h = URL.createObjectURL(f);
      g.setAttribute("href", h), g.setAttribute("download", b), g.style.visibility = "hidden", document.body.appendChild(g), g.click(), document.body.removeChild(g);
    }
  }
}